module.exports = __webpack_public_path__ + "1.4.15-unryo/img/private.1df45782.svg";